import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Consult from "./consult";
import Experience from "./experience";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function Bar2(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <SEOMeta
        title="neat.bar2, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat. bar2"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, bar2, neat bar2, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          {
            <span>
              더 정교해진 퍼포먼스와{isMobile ? <br /> : " "}심플한 디자인
            </span>
          }
        </div>
        <div className={style.device_title}>
          <img
            className={style.small_title}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/title_neat_bar${isMobile ? "_m" : ""}.webp`
            }
            alt="bar"
          />
          <div className={style.device_version}>Generation2</div>
        </div>
      </div>
      <div className={style.device_text}>
        중소형 회의실/강의실{isMobile ? <br /> : " "}최적환경 구성
      </div>

      <div className={style.device_img_list}>
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/bar2_1${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/bar2_2${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div className={style.device_description_img_box}>
          {isMobile ? (
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/device/neat/bar2_reddot_2024_m.webp"
              }
              alt="bar"
            />
          ) : (
            <>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/device/neat/bar2_device.webp"
                }
                alt="bar"
              />
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/device/neat/reddot_2024.webp"
                }
                alt="reddot"
              />
            </>
          )}
          <div className={style.device_description_text_box}>
            Neat Pad (컨트롤러) 포함
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/machine_learning${
                      isMobile ? "_m" : ""
                    }.webp`
                  }
                  alt="machine_learning"
                />
              </div>
              <div className={style.device_description_text}>
                지속적으로 조정·적응하는 <span>머신러닝을 통한</span> 직관적
                회의 경험
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/dual_screen${isMobile ? "_m" : ""}.webp`
                  }
                  alt="dual_screen"
                />
              </div>
              <div className={style.device_description_text}>
                <span>듀얼 스크린</span> 지원 · <span>위/아래</span> 장착 가능
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/sync${isMobile ? "_m" : ""}.webp`
                  }
                  alt="sync"
                />
              </div>
              <div className={style.device_description_text}>
                회의실을 감지하여 <span>자동으로 회의준비 및 종료</span>
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/setting${isMobile ? "_m" : ""}.webp`
                  }
                  alt="setting"
                />
              </div>
              <div className={style.device_description_text}>
                더 명확하고 선명한 <span>최첨단 비디오 오디오</span> 경험
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Bar Generation2 <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar2_1${isMobile ? "_m" : ""}.webp`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  우아하고 슬림한 디자인
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Bar Generation2는 정교하게 설계된 기술 구성 요소를 통합하여 얇은` +
                  `${isMobile ? " " : "\n"}` +
                  `화면이 이상적이며 모든 인테리어 스타일과 조화를 이루도록 디자인 되었습니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar2_2${isMobile ? "_m" : ""}.webp`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더욱 매력적인 회의를 위한 AI
                </div>
              </div>
              <div className={style.device_features_text}>
                {`향상된 학습 알고리즘을 사용하여 회의실의 음향 및 소음, 조명 조건 및` +
                  `${isMobile ? " " : "\n"}` +
                  `사람들의 움직임을 지속적으로 학습하고 이를 적응하여 향상된 회의의` +
                  `${isMobile ? " " : "\n"}경험을 제공합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar2_3${isMobile ? "_m" : ""}.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더욱 정교해진 오디오 기술
                </div>
              </div>
              <div className={style.device_features_text}>
                {`5개의 마이크 어레이, 향상된 4개의 음성 추적 마이크 등 고급 알고리즘을${
                  isMobile ? " " : "\n"
                }갖춘 neat bar generation 2는 보다 자연스러운 대화 흐름을 가능하게 합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {/* <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_bar2_4${isMobile ? "_m" : ""}.webp`
                }
                alt="feature4"
              /> */}
              <video
                autoPlay={true}
                muted={true}
                loop={true}
                controls={false}
                src={`${process.env.REACT_APP_CLIENT_URL}video/feature_bar2_4.mp4`}
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"4".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  강력한 비디오 품질
                </div>
              </div>
              <div className={style.device_features_text}>
                {`광각 50MP 카메라는 전체 회의 공간을 캡처하고 한 번에 여러 사람을 확대하고${
                  isMobile ? " " : "\n"
                }구도를 잡아 따라갈 수 있습니다. 초고속 비디오 처리를 통해 모든 사람이 어디에 있든${
                  isMobile ? " " : "\n"
                }동일한 비율로 볼 수 있으며, 그룹 View와 집중된 참가자 View의 동적 전환을${
                  isMobile ? " " : "\n"
                }지원하며, 클라우드가 아닌 장치에서 직접 하드웨어 가속 오디오 및 비디오${
                  isMobile ? " " : "\n"
                }처리를 구동합니다.`}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/neat/spec_bar2_1${isMobile ? "_m" : ""}.webp`}
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/spec_bar2_2${isMobile ? "_m" : ""}.webp`}
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/spec_bar2_3${isMobile ? "_m" : ""}.webp`}
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div className={style.device_spec_text_wrap}>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>카메라 및 시스템 LED</span>
                <span>가속도계</span>
                <span>듀얼 스크린 지원</span>
                <span>보안 잠금 슬롯(Kensington 호환)</span>
                <span>보안 부팅</span>
                <span>Zoom Rooms / Microsoft Teams Room</span>
                <span>웨이크업, 조도, 방향 센서</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "40px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>최대음역 최소왜곡 스피커</span>
                <span>진동방지 드라이버</span>
                <span>초음파 감지 컨텐츠공유</span>
                <span>추적 및 센서 마이크 4개</span>
                <span>빔포밍 마이크 5개</span>
                <span>하드웨어 가속 오디오 프로세서</span>
                <span>빔포밍</span>
                <span>에코 제거</span>
                <span>자동 게인 컨트롤</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>4x 디지털 줌(최대 8x 디지털 줌)</span>
                <span>50MP 캡처 해상도</span>
                <span>113도 수평 시야각</span>
                <span>자동 인물 프레이밍</span>
                <span>하드웨어 가속 비디오 인코딩 및 디코딩</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "45px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>Wi-Fi</span>
                <span>Bluetooth (MS Teams Proximity Join 기능)</span>
                <span>AC전원 (내장)</span>
                <span>이더넷 포트</span>
                <span>2 x HDMI 출력 </span>
                <span>HDMI 입력 (화면공유)</span>
                <span>USB-C : BYOD모드 또는 터치스크린 연결</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "87px" }}
            >
              <div className={style.device_spec_text_label}>크기 및 무게</div>
              <div className={style.device_spec_text}>
                <span>너비: 650mm(25.59인치)</span>
                <span>높이: 70mm(2.76인치)</span>
                <span>깊이: 70mm(2.76인치)</span>
                <span>무게: 1.7kg(3.75파운드)</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage: `url('${
              process.env.REACT_APP_CLIENT_URL
            }img/device/neat/spec_bar2_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>113°</div>
            <div className={style.device_spec_icon_label}>광각 카메라</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>50 MP</div>
            <div className={style.device_spec_icon_label}>센서 해상도</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>4x</div>
            <div className={style.device_spec_icon_label}>디지털 줌</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.micArray_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/mic_array${isMobile ? "_m" : ""}.webp`}
                alt="mic"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              5개 마이크 어레이
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.vibration_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/vibration${isMobile ? "_m" : ""}.webp`}
                alt="vibration"
              />
            </div>
            <div className={style.device_spec_icon_label}>진동 상쇄 설계</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.wifi_icon}
                src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/wifi${
                  isMobile ? "_m" : ""
                }.webp`}
                alt="wifi"
              />
            </div>
            <div className={style.device_spec_icon_label}>와이파이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                class={style.dualScreen_icon}
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/dual_screen_white${isMobile ? "_m" : ""}.webp`}
                alt="dualscreen"
              />
            </div>
            <div className={style.device_spec_icon_label}>듀얼 스크린 지원</div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>Sensors</div>
            <div className={style.device_spec_icon_label}>
              Wake-up·Light·{isMobile && <br />}Orientation
            </div>
          </div>
        </div>

        <Warranty />
      </div>
      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Bar2;
